<template>
    <CommonActionModal :dialog="dialogLeadEncontrado" :title="title" :subtitle="subtitle" bottonText="Si, abrir"
        @userChoice="changeRoute" />
</template>

<script>
import { loadScript } from "vue-plugin-load-script";
import { updateValidador } from "@/services/validador/validador.service.js";
import { findLeadValidador } from "@/services/leads/leads.service";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import { cleanValidadorId } from "@/services/leads/leads.service";
export default {
    data() {
        return {
            rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
            leadsLlamada: [],
            dialogInboundCalls: false,
            intervalo: {},
            agentStatus: null,
            currentState: false,
            dialogLeadEncontrado: false,
            title: "Se detectó llamada de validación entrante",
            subtitle: "",
        };
    },
    components: {
        CommonActionModal,
    },
    mounted() {
        if (this.rol == "VALIDADORCC" || this.rol == "MANAGERCC") { //TODO CAMBIAR ROL
            setTimeout(() => {
                loadScript(
                    "https://aligev55.zw-callitonce.alestra.net.mx/agentdesktop/libs/servicepattern-sdk-v1.js"
                ).then(() => {
                    console.log("Si cargo exitosamente");
                    window.bpspat.api.init(
                        "https://aligev55.zw-callitonce.alestra.net.mx"
                    );
                    setTimeout(() => {
                        this.intervalo = window.setInterval(() => {
                            this.checkStatus();
                        }, 10000);
                    }).catch(() => {
                        console.error(
                            "Fallo al cargar el sdk, Refresque la pagina para realizar la llamada"
                        );
                    });
                });
            }, 2000);
        }
    },
    methods: {
        async statusChecked(state) {
            const status = state.data.status ?? null;
            switch (status) {
                case "ready":
                    if (!this.currentState) {
                        this.currentState = true;
                        this.$toast.success(
                            "Listo para validar leads por conferencia automatica."
                        );
                        await this.updateValidadorStatus(1);
                    }
                    break;
                case "busy": {
                    const interactions = state?.data?.interactions ?? [];
                    if (interactions.length === 0) break;
                    const llamada = interactions.find((e) => e.media_type === "VOICE");
                    if (!llamada) break;
                    const leadValidador = await this.findLeadValidador(
                        llamada.phone_number
                    );
                    if (leadValidador.total > 0) {
                        clearInterval(this.intervalo);
                        this.checkIfIntervalo(leadValidador);
                    }
                    break;
                }
                default:
                    if (
                        this.currentState != false ||
                        window.location.pathname == "/leads" ||
                        window.location.pathname.includes("/segurify/leads-segurify/lead/")
                    ) {
                        this.currentState = false;
                        await this.updateValidadorStatus(0);
                        this.$toast.info("Validador automatico detenido");
                    }
                    break;
            }
        },
        checkStatus() {
            window.bpspat.api.getState(this.statusChecked);
        },
        async updateValidadorStatus(isDisponible) {
            try {
                await updateValidador(isDisponible);
            } catch {
                console.error("Error a actualizar validador.");
            }
        },
        async findLeadValidador(telefono) {
            try {
                return await findLeadValidador(telefono);
            } catch {
                console.error("Error a actualizar validador.");
            }
        },
        checkIfIntervalo(leadValidador) {
            this.lead = leadValidador.data[0];
            let request_json = this.lead.request_json
                ? JSON.parse(this.lead.request_json)
                : {};

            this.subtitle = `Ir al perfil del lead: ${request_json.nombre ? request_json.nombre : " "
                } ${request_json.apellidoPaterno ? request_json.apellidoPaterno : " "} ${request_json.apellidoMaterno ? request_json.apellidoMaterno : " "
                }`;
            this.dialogLeadEncontrado = true;
        },
        async changeRoute(response) {
            if (!response) {
                this.dialogLeadEncontrado = false;
                let response = this.cleanValidadorId();
                if (response) this.$toast.info("Lead liberado del validador");
            } else {
                this.currentState = false;
                await this.updateValidadorStatus(0);
                this.$toast.info("Validador automatico detenido");
                this.$router.push({
                    path: "/segurify/leads-segurify/lead/" + this.lead.uuid_lead_segurify,
                    query: {
                        llamadaValidador: true,
                        origenLeadUuid: this.lead.uuid,
                    },
                });
            }
        },
        async cleanValidadorId() {
            return await cleanValidadorId(this.lead.uuid_lead_segurify);
        },
    },
};
</script>